import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_FAQ = createActionType("ADD_FAQ");
export const GET_FAQS = createActionType("GET_FAQS");
export const GET_FAQ_BY_ID = createActionType("GET_FAQ_BY_ID");
export const EDIT_FAQ = createActionType("EDIT_FAQ");
export const REMOVE_FAQ = createActionType("REMOVE_FAQ");

export const addFaq = (data: any) =>
  createAsyncAction(ADD_FAQ, "/question/add_question", "post", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const getFaqs = () =>
  createAsyncAction(GET_FAQS, "/question/get_all_questions", "get", undefined);

export const getArticleById = (data: any) =>
  createAsyncAction(
    GET_FAQ_BY_ID,
    `/article/get_article_by_id/${data}`,
    "get",
    undefined
  );

export const editFaq = (id: any, data: any) =>
  createAsyncAction(
    EDIT_FAQ,
    `/question/edit_question_by_id/${id}`,
    "put",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeFaq = (data: any) =>
  createAsyncAction(
    REMOVE_FAQ,
    `/question/remove_question_by_id/${data}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
